export default "__VITE_ASSET__DIVQbc4H__"